import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=3226ba7e&scoped=true&"
import script from "./UploadImage.vue?vue&type=script&lang=js&"
export * from "./UploadImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=3226ba7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3226ba7e",
  null
  
)

export default component.exports